module.exports = __webpack_public_path__ + "static/media/dotted-square-dark.784aa75e.svg";